import { RouterOutlet } from '@angular/router';
import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [ RouterOutlet ],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss'
})

export class AppComponent {

	constructor() { }

}